"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarChip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _avatar = require("../../avatar");
var _BaseChip = require("../components/BaseChip");
var _AvatarWrapper = require("../styled/AvatarWrapper");
var _chipTheme = require("../styled/chipTheme");
const StyledBaseChip = (0, _styled.default)(_BaseChip.BaseChip)`
    border-radius: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _chipTheme.avatarChipTheme.borderRadius(themeMode);
}};
    padding-left: ${_ref2 => {
  let {
    themeMode,
    size
  } = _ref2;
  return _chipTheme.avatarChipTheme.padding.left[size](themeMode);
}};
    padding-right: ${_ref3 => {
  let {
    themeMode,
    size
  } = _ref3;
  return _chipTheme.avatarChipTheme.padding.right[size](themeMode);
}};
`;
const AvatarChip = /*#__PURE__*/(0, _react.forwardRef)((_ref4, ref) => {
  let {
    avatarProps,
    chipType = "default",
    ...rest
  } = _ref4;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const getChipBaseColor = (0, _react.useCallback)(chipType => {
    return _chipTheme.chipTheme.chip.color[chipType].color(themeMode);
  }, [themeMode]);
  const icons = {
    info: {
      "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.InfoFilledIcon, {
        size: "xSmall"
      }),
      "ursa-light": /*#__PURE__*/_react.default.createElement(_ursaIcons.InfoFilledIcon, {
        size: 16,
        color: "currentColor"
      })
    },
    warning: {
      "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.AlertWarningIcon, {
        size: "xSmall"
      }),
      "ursa-light": /*#__PURE__*/_react.default.createElement(_ursaIcons.WarningFilledIcon, {
        size: 16,
        color: "currentColor"
      })
    },
    error: {
      "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.AlertErrorIcon, {
        size: "xSmall"
      }),
      "ursa-light": /*#__PURE__*/_react.default.createElement(_ursaIcons.ExclamationOnDotIcon, {
        size: 16,
        color: "currentColor"
      })
    },
    default: {
      "lodestar-light": avatarProps.content,
      "ursa-light": avatarProps.content
    }
  };
  const updatedAvatarProps = {
    ...avatarProps,
    src: chipType === "default" ? avatarProps.src : undefined,
    email: chipType === "default" ? avatarProps.email : undefined,
    content: icons[chipType][themeMode],
    color: chipType === "default" ? avatarProps.color : {
      backgroundColor: "transparent",
      textColor: "auto"
    }
  };
  return /*#__PURE__*/_react.default.createElement(StyledBaseChip, (0, _extends2.default)({}, rest, {
    ref: ref,
    color: getChipBaseColor(chipType),
    themeMode: themeMode,
    size: rest.size || _chipTheme.chipTheme.chip.size(themeMode),
    contentBefore: /*#__PURE__*/_react.default.createElement(_AvatarWrapper.AvatarWrapper, {
      themeMode: themeMode
    }, /*#__PURE__*/_react.default.createElement(_avatar.Avatar, (0, _extends2.default)({}, updatedAvatarProps, {
      "aria-hidden": true,
      role: "presentation",
      tabIndex: -1,
      size: "xxSmall"
    })))
  }));
});
exports.AvatarChip = AvatarChip;
AvatarChip.displayName = "AvatarChip";
//# sourceMappingURL=AvatarChip.js.map